﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { setSearchHistory } from '../../../../Resources/Scripts/_Shared/history';

function myaimoparkloadmore(context) {
  const style_element = document.createElement('STYLE');
  let list = context.querySelector('[data-list]');
  let listItems = list?.childNodes ?? [];
  const button = context.querySelector('[data-load-more]');
  let observer;
  let buttonClick = false;

  let urlParams;
  let itemIncrement = 10;
  let itemsToShow;

  function init() {
    if (!list)
      return;

    urlParams = new URLSearchParams(window.location.search);
    itemsToShow = urlParams.get('items') ? parseInt(urlParams.get('items'), 10) : itemIncrement;
    list.setAttribute('data-items', itemsToShow);

    if (listItems.length > itemIncrement) {
      button.addEventListener('click', function() {
        buttonClick = true;
        setTimeout(() => buttonClick = false, 250);

        itemsToShow = parseInt(itemsToShow, 10) + itemIncrement;
        list.setAttribute('data-items', itemsToShow);
      });

      document.getElementsByTagName('HEAD')[0].appendChild(style_element);
      observer = new MutationObserver(observerCallback);
      observer.observe(list, { attributes: true });
    }

    observerCallback();
  }

  const observerCallback = function() {
    if (list.dataset.items && parseInt(list.dataset.items, 10) !== itemsToShow && !buttonClick) {
      itemsToShow = parseInt(list.dataset.items, 10);
      setSearchHistory({ items: itemsToShow });
    }
    else if (itemsToShow !== itemIncrement) {
      setSearchHistory({ items: itemsToShow });
    }

    const itemsToShowStyle = itemsToShow + 1;
    const itemsToShowStyleAlt = (itemsToShow * 2) + 1;

    setVisibleStyle(`
      [data-controller="myaimopark-loadmore"] > [data-list] > li,
      [data-controller="myaimopark-loadmore"] > [data-list] > dt {
        display: flex;
      }
      [data-controller="myaimopark-loadmore"] > [data-list] > li:nth-child(n + ${itemsToShowStyle}),
      [data-controller="myaimopark-loadmore"] > [data-list] > dt:nth-child(n + ${itemsToShowStyleAlt}) {
        display: none;
      }
    `)

    if (itemsToShow >= list.childElementCount)
      button.setAttribute('aria-hidden', 'true'), button.style.display = 'none';
    else
      button.removeAttribute('aria-hidden'), button.style.removeProperty('display');
  }

  const setVisibleStyle = function(css_text) {
    !!style_element.styleSheet ?
      style_element.styleSheet.cssText = css_text :
      style_element.innerHTML = css_text;
  }

  return {
    init
  };
}

controller.add('myaimopark-loadmore', myaimoparkloadmore);